import { AutogenModelOrdersLookupAddBalancedue, AutogenRowOrdersLookupAddBalancedue } from "./autogen/AutogenModelOrdersLookupAddBalancedue";

export class ModelOrdersLookupAddBalancedue extends AutogenModelOrdersLookupAddBalancedue<RowOrdersLookupAddBalancedue> {
	constructor() {
		super(RowOrdersLookupAddBalancedue);
	}
}

export class RowOrdersLookupAddBalancedue extends AutogenRowOrdersLookupAddBalancedue {
}